import React from 'react';
import { motion } from 'framer-motion';
import { Coins } from 'lucide-react';
const creditTiers = [{
  cash: '$200 cash',
  credits: '$300 in credits'
}, {
  cash: '$600 cash',
  credits: '$900 in credits'
}, {
  cash: '$1,500 cash',
  credits: '$2,250 in credits'
}, {
  cash: '$5,000 cash',
  credits: '$7,500 in credits'
}, {
  cash: '$10,000 cash',
  credits: '$15,000 in credits'
}];
export function CreatorCreditsOrCash() {
  return <section className="py-20 md:py-28 px-6 md:px-8 max-w-5xl mx-auto" data-id="element-2471" data-mp="3tvprb4tkdwaw">
      <div className="text-center mb-16" data-id="element-2472" data-mp="2owhjckpgour">
        <h2 className="font-title font-bold text-4xl md:text-6xl tracking-tight text-[#2B211A] mb-4" data-id="element-2473" data-mp="2nv451g7vq9v">
          Credits or cash
        </h2>
        <p className="text-neutral-500 text-lg" data-id="element-2474" data-mp="cg99032ldd09">
          You choose with each submission.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-6 items-stretch" data-id="element-2475" data-mp="gie1uzl7u5lu">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative rounded-[2.5rem] p-8 md:p-12 bg-[#FCF3EC] border border-[#EA580C]/20 flex flex-col h-full shadow-sm" data-id="element-2476" data-mp="lgfmhoyaiczf">
          
          <div className="w-14 h-14 rounded-2xl bg-[#EA580C] flex items-center justify-center mb-10 shadow-lg shadow-[#EA580C]/30 shrink-0" data-id="element-2477" data-mp="370whkfrc2d6e">
            <span className="font-title font-bold text-white text-2xl leading-none" data-id="element-2478" data-mp="323d3bfumy0eg">
              G
            </span>
          </div>
          <div className="flex items-center justify-between flex-wrap gap-3 mb-6" data-id="element-2479" data-mp="3m8xo9ts9945">
            <h3 className="font-title font-bold text-3xl text-[#EA580C]" data-id="element-2480" data-mp="3uriog3plpret">
              Giga Credits
            </h3>
            <span className="px-4 py-1.5 rounded-full bg-[#EA580C] text-white text-sm font-bold" data-id="element-2481" data-mp="3pxnzolv52m8v">
              50% more with credits
            </span>
          </div>
          <p className="text-[#EA580C]/80 text-[15px] md:text-base leading-relaxed mb-10 max-w-sm" data-id="element-2482" data-mp="mci826zq476x">
            We add 1.5x the cash equivalent to your Giga account. More tasks,
            more automations, more AI coworker time. Automatic. No strings.
          </p>
          <div className="divide-y divide-[#EA580C]/10 border-t border-[#EA580C]/10 mt-auto" data-id="element-2483" data-mp="2ftwd1bbrsqqt">
            {creditTiers.map((tier, i) => <div key={i} className="flex items-center justify-between py-4" data-id="element-2484" data-mp="221q7ska5o465" data-mpi={i}>
                <span className="font-medium text-[#2B211A] text-base" data-id="element-2485" data-mp="270ax3onvd3ft">
                  {tier.cash}
                </span>
                <span className="font-bold text-[#EA580C] text-base" data-id="element-2486" data-mp="1s2ilh7lg0z6w">
                  {tier.credits}
                </span>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="rounded-[2.5rem] p-8 md:p-12 bg-white border border-neutral-200 shadow-sm flex flex-col h-full" data-id="element-2487" data-mp="1j4p0gst4prz1">
          
          <div className="w-14 h-14 rounded-2xl bg-white border border-neutral-200 shadow-sm flex items-center justify-center mb-10 shrink-0" data-id="element-2488" data-mp="3ieeznj8ivzwh">
            <Coins className="w-7 h-7 text-neutral-400" strokeWidth={2} data-id="element-2489" data-mp="3nlv6ptxrq05h" />
          </div>
          <div className="flex items-center justify-between flex-wrap gap-3 mb-6" data-id="element-2490" data-mp="573yk3apsf17">
            <h3 className="font-title font-bold text-3xl text-[#2B211A]" data-id="element-2491" data-mp="gnjker8wlcq">
              Cash
            </h3>
            <span className="px-4 py-1.5 rounded-full bg-neutral-100 text-neutral-600 text-sm font-bold" data-id="element-2492" data-mp="f59xqd54z72d">
              Paid through Dub
            </span>
          </div>
          <p className="text-neutral-500 text-[15px] md:text-base leading-relaxed max-w-sm" data-id="element-2493" data-mp="a8jghmhli5fd">
            Paid through{' '}
            <a href="#" className="underline underline-offset-2 text-[#2B211A] hover:text-[#EA580C] transition-colors" data-id="element-2494" data-mp="k4w9sj98ah9l">
              
              Dub
            </a>
            . Apply once. Add your payout details. Get paid within 5 business
            days. No invoicing.
          </p>
        </motion.div>
      </div>
    </section>;
}